export type PropertyListing = {
  id: string;
  title: string;
  suburb: string;
  state: string;
  weeklyRent: number;
  bedType: string;
  bathrooms: number;
  availableNow: boolean;
  features: string[];
  image: string;
  tag?: string;
  region: 'regional' | 'metro';
};

export const propertyListings: PropertyListing[] = [
  {
    id: 'p1',
    title: 'Furnished Room — Dubbo',
    suburb: 'Dubbo',
    state: 'NSW',
    weeklyRent: 210,
    bedType: 'Queen Bed',
    bathrooms: 1,
    availableNow: true,
    region: 'regional',
    features: ['Bills Included', 'Free Wi-Fi', 'Furnished', 'Cleaning Service'],
    image: 'https://readdy.ai/api/search-image?query=clean%20modern%20furnished%20bedroom%20with%20queen%20bed%20white%20linen%2C%20wardrobe%2C%20desk%2C%20natural%20light%20through%20window%2C%20minimalist%20Australian%20private%20room%20for%20rent%2C%20bright%20and%20tidy%20interior&width=600&height=380&seq=rental1&orientation=landscape',
    tag: 'Available Now',
  },
  {
    id: 'p2',
    title: 'Private Room — Toowoomba',
    suburb: 'Toowoomba',
    state: 'QLD',
    weeklyRent: 200,
    bedType: 'Double Bed',
    bathrooms: 1,
    availableNow: true,
    region: 'regional',
    features: ['Bills Included', 'Free Wi-Fi', 'Furnished', 'Cleaning Service'],
    image: 'https://readdy.ai/api/search-image?query=bright%20clean%20furnished%20double%20bedroom%20with%20neat%20bed%2C%20storage%20wardrobe%2C%20window%20with%20curtains%2C%20simple%20minimalist%20decor%2C%20modern%20Australian%20shared%20house%20private%20room%2C%20natural%20daylight&width=600&height=380&seq=rental2&orientation=landscape',
    tag: 'Available Now',
  },
  {
    id: 'p3',
    title: 'Comfortable Room — Ballarat',
    suburb: 'Ballarat',
    state: 'VIC',
    weeklyRent: 220,
    bedType: 'Double Bed',
    bathrooms: 1,
    availableNow: false,
    region: 'regional',
    features: ['Bills Included', 'Free Wi-Fi', 'Furnished', 'Cleaning Service'],
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20furnished%20room%20with%20double%20bed%2C%20clean%20white%20walls%2C%20timber%20flooring%2C%20wardrobe%2C%20desk%20lamp%2C%20bright%20natural%20light%2C%20private%20room%20Australian%20house%20for%20rent%20interior%20photography&width=600&height=380&seq=rental3&orientation=landscape',
    tag: 'Coming Soon',
  },
  {
    id: 'p4',
    title: 'Room with Ensuite — Parramatta',
    suburb: 'Parramatta',
    state: 'NSW',
    weeklyRent: 310,
    bedType: 'Queen Bed',
    bathrooms: 1,
    availableNow: true,
    region: 'metro',
    features: ['Bills Included', 'Free Wi-Fi', 'Furnished', 'Ensuite', 'Cleaning Service'],
    image: 'https://readdy.ai/api/search-image?query=clean%20furnished%20private%20bedroom%20with%20ensuite%20bathroom%2C%20queen%20bed%2C%20crisp%20white%20linen%2C%20bright%20Australian%20home%20interior%2C%20modern%20and%20tidy%20room%20for%20rent%2C%20natural%20light%20windows&width=600&height=380&seq=rental4&orientation=landscape',
    tag: 'Available Now',
  },
  {
    id: 'p5',
    title: 'Furnished Room — Townsville',
    suburb: 'Townsville',
    state: 'QLD',
    weeklyRent: 195,
    bedType: 'Single Bed',
    bathrooms: 1,
    availableNow: true,
    region: 'regional',
    features: ['Bills Included', 'Free Wi-Fi', 'Furnished', 'Cleaning Service'],
    image: 'https://readdy.ai/api/search-image?query=cozy%20neat%20single%20bedroom%20with%20clean%20bed%20white%20sheets%2C%20simple%20minimalist%20furnishings%2C%20bright%20light%2C%20clean%20walls%2C%20tidy%20private%20room%20in%20Australian%20home%2C%20peaceful%20and%20quiet%20atmosphere&width=600&height=380&seq=rental5&orientation=landscape',
    tag: 'Available Now',
  },
  {
    id: 'p6',
    title: 'Private Room — Footscray',
    suburb: 'Footscray',
    state: 'VIC',
    weeklyRent: 290,
    bedType: 'Queen Bed',
    bathrooms: 1,
    availableNow: true,
    region: 'metro',
    features: ['Bills Included', 'Free Wi-Fi', 'Furnished', 'Cleaning Service'],
    image: 'https://readdy.ai/api/search-image?query=spacious%20bright%20furnished%20room%20large%20queen%20bed%20wooden%20floor%2C%20curtains%2C%20wardrobe%20built-in%2C%20clean%20minimalist%20decor%2C%20Australian%20rental%20property%20bedroom%2C%20natural%20sunlight%20interior&width=600&height=380&seq=rental6&orientation=landscape',
    tag: 'Available Now',
  },
  {
    id: 'p7',
    title: 'Bright Room Near Station — Orange',
    suburb: 'Orange',
    state: 'NSW',
    weeklyRent: 205,
    bedType: 'Double Bed',
    bathrooms: 1,
    availableNow: false,
    region: 'regional',
    features: ['Bills Included', 'Free Wi-Fi', 'Furnished', 'Cleaning Service'],
    image: 'https://readdy.ai/api/search-image?query=bright%20natural%20light%20furnished%20bedroom%20double%20bed%20neat%20white%20linen%2C%20clean%20walls%2C%20simple%20wardrobe%2C%20desk%2C%20tidy%20minimalist%20Australian%20private%20room%20interior%2C%20warm%20homely%20atmosphere&width=600&height=380&seq=rental7&orientation=landscape',
    tag: 'Coming Soon',
  },
  {
    id: 'p8',
    title: 'Modern Furnished Room — Brisbane Southside',
    suburb: 'Brisbane',
    state: 'QLD',
    weeklyRent: 295,
    bedType: 'Queen Bed',
    bathrooms: 1,
    availableNow: true,
    region: 'metro',
    features: ['Bills Included', 'Free Wi-Fi', 'Furnished', 'Ensuite', 'Cleaning Service'],
    image: 'https://readdy.ai/api/search-image?query=modern%20clean%20furnished%20bedroom%20queen%20size%20bed%2C%20white%20linen%2C%20timber%20flooring%2C%20wardrobe%20mirror%20sliding%20door%2C%20desk%2C%20bright%20natural%20light%20large%20windows%2C%20premium%20Australian%20rental%20room&width=600&height=380&seq=rental8&orientation=landscape',
    tag: 'Available Now',
  },
];
